import 'dotenv/config';
import { createApp } from './app';
import { loadConfigFromEnv } from './config/env';
import { logError, logInfo } from './logging/logger';

const config = loadConfigFromEnv();
const app = createApp({ config });

const server = app.listen(config.port, config.host, () => {
  logInfo('server_started', {
    port: config.port,
    static: config.serveStatic,
  });
});

server.on('error', (error: NodeJS.ErrnoException) => {
  logError('server_error', { name: error.name });
  process.exitCode = 1;
});
